import { call, put, select, delay, takeLatest } from 'redux-saga/effects'
import { get, filter} from 'lodash'

import { makeGetAttendantByPin } from '../selectors/attendant'
import { getEmployeeApprovalCodes } from '../selectors/employeeRole'

import { setActiveAttendantId, clearAttemptPinLoginStatus, clearFetchAttendantsStatus, LOGOUT, fetchAttendants } from '../actions/attendant'

import {
  ATTEMPT_PIN_LOGIN,
  ATTEMPT_PIN_LOGIN_OFFLINE,
  FETCH_ATTENDANTS,
  fetchAttendantsSucceeded,
  fetchAttendantsFailed,
  attemptPinLoginSucceeded,
  attemptPinLoginFailed,
} from '../actions/attendant'

import {
  fetchAttendantSettingsSucceeded,
  fetchAttendantSettingsFailed,
} from '../actions/attendantSettings'

import Remote from '../remote'
import { preOrdersRequested } from '../actions/order'
import { clearPromotionsOnOrder } from '../actions/promotion'
import { clearCart } from '../actions/cart'

const getAttendantByPin = makeGetAttendantByPin()

const resolveErrorMessage = (messages) => {
  return messages?.find?.(message => !!message)
}

const filterAttendants = (attendants = []) =>
  filter(attendants, (attendant) =>
    attendant?.deactivatedAt === null
  )

export function* fetchAttendantsSaga() {
  const venueUuid = process.env.REACT_APP_VENUE_UUID

  try {
    const result = yield call(Remote.getAttendants, venueUuid)
    const activeAttendants = filterAttendants(result?.data?.attendants)
    yield put(fetchAttendantsSucceeded(activeAttendants))
  } catch (err) {
    yield put(fetchAttendantsFailed(err))
  }
}

export function* watchFetchAttendantsSaga() {
  yield takeLatest(FETCH_ATTENDANTS, fetchAttendantsSaga)
}

function* attemptPinLoginSaga(action) {
  const pin = get(action, 'payload.pin')
  const venueUuid = process.env.REACT_APP_VENUE_UUID

  try {
    const result = yield call(Remote.getAttendantSettings, pin, venueUuid)

    if (result?.data?.attendantSettings?.length === 0) {
      throw Error('Attendant is not configured')
    }

    const attendantUuid = result?.data?.attendantSettings?.[0]?.employeeUuid

    yield put(setActiveAttendantId(attendantUuid))
    yield put(attemptPinLoginSucceeded())
    yield put(fetchAttendantSettingsSucceeded(result))
  } catch (err) {
    const errorMessage = resolveErrorMessage([
      err?.response?.data?.errorMessage,
      err?.message,
      'An unknown error occurred',
    ])

    yield put(fetchAttendantSettingsFailed({ errorMessage }))
    yield put(attemptPinLoginFailed())
  }
}

export function* watchAttemptPinLoginSaga() {
  yield takeLatest(ATTEMPT_PIN_LOGIN, attemptPinLoginSaga)
}

function* attemptPinLoginOfflineSaga(action) {
  const pin = action?.payload?.pin

  const approvalCodes = yield select(getEmployeeApprovalCodes)
  if (approvalCodes?.includes(pin)){
    const attendant = yield select(getAttendantByPin, pin)
    const attendantUuid = attendant?.uuid

    yield put(setActiveAttendantId(attendantUuid))
    yield put(attemptPinLoginSucceeded())
  } else {
    yield put(fetchAttendantSettingsFailed({ errorMessage: "Attendant not found" }))
    yield put(attemptPinLoginFailed())
  }
}

export function* watchAttemptPinLoginOfflineSaga() {
  yield takeLatest(ATTEMPT_PIN_LOGIN_OFFLINE, attemptPinLoginOfflineSaga)
}

function* logoutSaga() {
  yield put(setActiveAttendantId(undefined))
  yield put(clearAttemptPinLoginStatus())
  yield put(clearFetchAttendantsStatus())
  yield put(clearPromotionsOnOrder())
  yield put(clearCart())
}

export function* watchLogoutSaga() {
  yield takeLatest(LOGOUT, logoutSaga)
}
